import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useStringTemplate } from '@blaze-cms/utils-handlebars';
const withTitle = Component => {
  const InnerComponent = props => {
    const {
      elementTitle,
      isHeroImg,
      parent
    } = props;
    const shouldDisplayTitle = elementTitle && !isHeroImg;
    const {
      loading,
      data: [elementTitleToUse]
    } = useStringTemplate(parent, [elementTitle]);
    if (loading) return '';
    return /*#__PURE__*/React.createElement(Fragment, null, shouldDisplayTitle && /*#__PURE__*/React.createElement("h2", {
      className: "heading heading--section"
    }, elementTitleToUse), /*#__PURE__*/React.createElement(Component, props));
  };
  InnerComponent.WrappedComponent = Component;
  InnerComponent.displayName = `WithTitle(${Component.displayName || Component.name || 'Component'})`;
  InnerComponent.propTypes = {
    parent: PropTypes.object,
    elementTitle: PropTypes.string,
    isHeroImg: PropTypes.bool
  };
  InnerComponent.defaultProps = {
    parent: {},
    elementTitle: '',
    isHeroImg: false
  };
  return InnerComponent;
};
export default withTitle;
//# sourceMappingURL=withTitle.js.map